import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_s5r5bgxjku: FaireBrandEntity = {
  token: "b_s5r5bgxjku",
  type: "brand",
  name: "Good Juju Body & Home",
  avatarUrl:
    "https://cdn.faire.com/fastly/ecd0b2ed2e5f7e58cb1915d8f5ff17e29482c800e131c2be35e1d7629a9974fa.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e367411fe18ffbafb5fb22a1cdd51bfdf005d10843651888a6d9a2dc5b4f2ca8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/ecd0b2ed2e5f7e58cb1915d8f5ff17e29482c800e131c2be35e1d7629a9974fa.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e367411fe18ffbafb5fb22a1cdd51bfdf005d10843651888a6d9a2dc5b4f2ca8.jpeg",
  location: "Vancouver, BC, CAN",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 38,
  isTopShop: true,
  isInsider: false,
  description:
    "Good Juju Body & Home is a women-led, BIPOC, Canadian brand that makes premium zero-waste beauty and home care products. Co-founders Alexa and Lisa started Good Juju after spending our careers in the natural health industry, and everything we make is informed by our motto, Zero Waste with Zero Compromise.\n\nGood Juju’s high-performance products are formulated with the help of a Naturopathic Doctor and Researcher who has worked out of Harvard and the University of Toronto, and they contain innovative, natural, science-backed ingredients. We have a product line up of award-winning shampoo and conditioner bars that are available in four formulas to suit all hair types, laundry strips in three delectable scents, and a moisturizing no-foam shave bar with collagen-boosting ingredients. \n\nBeyond the incredible products, Good Juju consistently champions diversity and inclusion because it's a central component of creating a more just and sustainable world telling our creative story with people of different genders, body shapes, sizes, and colours.  Through product formulation and diverse, representative imagery, we are making zero waste an inclusionary movement.\n\nWe are an Earth First company on a mission to prevent 50 million plastic bottles from ever being made by 2030. We'd love your help getting there!\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:25.873Z",
    importedBy: "entity-db-cli",
  },
};
